module.exports = __webpack_public_path__ + "hero-alertminer.1a42f9f56feff78b79e2.png";